import { HStack } from 'ui_2';
import { ArcadeTicketBalance } from './ArcadeTicketBalance';
import { ConnectOrAccount } from './ConnectOrAccount';
import { useArcadeStoreState } from '@src/hooks/useArcadeStoreState';
import { CountrySelector } from './countries/CountrySelector';

type Props = {
  showConnectOrAccount?: boolean;
};
export const AccountAndBalance = ({ showConnectOrAccount = true }: Props) => {
  const { isPuzzleWalletWebview } = useArcadeStoreState();

  return (
    <HStack className='items-center gap-4'>
      <CountrySelector />
      <ArcadeTicketBalance />
      {showConnectOrAccount && (
        <ConnectOrAccount showOnConnected={isPuzzleWalletWebview === false} />
      )}
    </HStack>
  );
};
